export default __webpack_public_path__ + "static/1be54b7a3bca19d5053ed5c6194c139e.webp";